module.exports = __webpack_public_path__ + "img/tschuki_text.2dfe3708.png";